module.exports = __webpack_public_path__ + "images/img-1s5QctB.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/1.png
// module id = 2333
// module chunks = 0